import * as FileSaver from 'file-saver';
import * as moment from 'moment';

/**
 * Saves a server-returned blob (e.g. an Excel export) to disk, using the same
 * `file-saver` idiom already used for downloads elsewhere in the app
 * (see orders-edit.component.ts `handleDownloadOrders`).
 */
export class FileDownloadUtil {
  static saveBlob(blob: Blob, fileName: string): void {
    FileSaver.saveAs(blob, fileName);
  }

  /**
   * Builds a safe, human-readable export file name from a page's own label (typically its
   * breadcrumb `active` value) plus today's date, e.g. "Manage_Orders_16-09-2026.xlsx".
   * Centralized here so the date format only needs to change in one place.
   */
  static buildExportFileName(label: string, extension = 'xlsx'): string {
    const safeLabel = label.trim().replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '');
    const datePart = moment().format('DD-MM-YYYY');
    return `${safeLabel}_${datePart}.${extension}`;
  }
}
